import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import MaterialTypography from "../../../components/MaterialTypography";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Stack,
  Button,
  TextField,
} from "@mui/material";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import { useUserDetails } from "../../../context/auth";
import Swal from "sweetalert2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
function LeaveApproval() {
  const [employeeData, setemployeeData] = useState([]);
  console.log('employeeData:',employeeData);
  
  const [ID, setID] = useState("");

  const navigate = useNavigate();
  const { HRRoleLeave, ManagerLeave, AccessData,HRLIST } = useUserDetails();

  let Roledata = JSON.parse(sessionStorage.getItem('MainApp'));

  console.log('Roledata:',Roledata);
  const [Alldata,setAlldata] = useState('')
  
  const [display, setdisplay] = useState(false);
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setID(id);
    if (id) {
      getemployeedata(id);
    }
  }, []);

  // const getemployeedata = async (id) => {
  //   const query = ` query get_leave($id: String!) {
  //               getLeaveById(id: $id) {
  //                   id
  //                   requestedOn
  //                   leaveType{
  //                   leaveType
  //                   }
  //                   leaveFrom
  //                   leaveTill
  //                   totalDays
  //                   reason
  //                   teamApproval
  //                   hrApproval
  //                   halfDay
  //                   status
  //                   lastUpdate
  //                   teamleaderId
  //                   user{
  //                   firstName
  //                   }
  //               }
  //           }
  // `;
  //   try {
  //     const response = await axios.post(
  //       BASEURL,
  //       {
  //         query: query,
  //         variables: { id },
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     const leaveDatass = response.data.data.getLeaveById;
  //     console.log("leaveDatass:", leaveDatass);
  //     setemployeeData(leaveDatass);
  //     if (
  //       AccessData &&
  //       Array.isArray(AccessData) &&
  //       AccessData.some(
  //         (item) => item.module === "ApplyLeave" && item.component === "ManagerApproval" && item.can_access
  //       )
  //     ) {
  //       console.log('Error1');
        
  //       setdisplay(true);
      
  //     }
  //     if (leaveDatass.teamApproval == "approved") {
  //       console.log('Error2')
  //       setdisplay(true);
  //     } else if (leaveDatass.teamApproval == "rejected") {
  //       setdisplay(false);
  //     }

    
  //   } catch (error) {
  //     console.log("ReponseError:", error);
  //   }
  // };



  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });


  const getemployeedata = async (id) => {
    const query = ` query get_leave($id: String!) {
                getLeaveById(id: $id) {
                    id
                    requestedOn
                    leaveType{
                    leaveType
                    }
                    leaveFrom
                    leaveTill
                    totalDays
                    reason
                    teamApproval
                    hrApproval
                    halfDay
                    status
                    lastUpdate
                    teamleaderId
                    user{
                    firstName
                    }
                }
            }
  `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const leaveDatass = response.data.data.getLeaveById;
      setAlldata(leaveDatass)
      console.log("leaveDatass:", leaveDatass);
      setemployeeData(leaveDatass);
      if (
        AccessData &&
        Array.isArray(AccessData) &&
        AccessData.some(
          (item) => item.module === "ApplyLeave" && item.component === "ManagerApproval" && item.can_access
        )
      ) {
        console.log('Error1');
        
        if (leaveDatass.teamApproval == "Pending") {
          setdisplay(true);
          console.log("THIEUEHD");
        }else {
          setdisplay(false);
        }
      
      }else if (  AccessData &&
        Array.isArray(AccessData) &&
        AccessData.some(
          (item) => item.module === "ApplyLeave" && item.component === "HrApproval" && item.can_access
        )){
        
        if(Roledata == 'HRList'){
          if(leaveDatass.teamApproval =='Pending'){
            setdisplay(true)
            console.log('THIEUEHD');
            
          }
        }else if (Roledata =='HR'){
          if(leaveDatass.teamApproval =='approved' && leaveDatass.hrApproval == 'Pending'){
            setdisplay(true)
          }
        }

        }
     
     


    

      // if (leaveDatass.teamApproval == "approved") {
      //   console.log('Error2')
      //   setdisplay(true);
      // } else if (leaveDatass.teamApproval == "rejected") {
      //   setdisplay(false);
      // }

    
    } catch (error) {
      console.log("ReponseError:", error);
    }
  };

  const handleAddLeave = (statusdata) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: `Are you sure you want to ${statusdata == 'approved' ? 'Approve' : statusdata == 'rejected' ? 'Reject' : '' } the leave?`,
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ApproveSubmit(statusdata);
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const ApproveSubmit = async (statusdata) => {
    
    let query;

    if (
      AccessData &&
      Array.isArray(AccessData) &&
      AccessData.some(
        (item) => item.component === "HrApproval" && item.can_access
      )
    ) {

      if(Roledata == 'HRList'){
        if(Alldata.teamApproval =='Pending'){

          console.log('jnjncndbbdcc');
          
          query = `
          mutation leaveManagerApproval($id: String!, $status: String!) {
            leaveapprovalmanager(id: $id, status: $status) {
              leaveApprovalManager {
                id
                requestedOn
                leaveType {
                  leaveType
                }
                leaveFrom
                leaveTill
                totalDays
                halfDay
                reason
                status
                hrApproval
                teamleaderId
                teamApproval
              }
            }
          }
        `;
          
        }
      }else if(Roledata =='HR' && Alldata.teamApproval == 'approved' && Alldata.hrApproval == 'Pending'){
        query = `
        mutation leaveHrApproval($id: String!, $status: String!) {
  leaveapprovalhr(id: $id, status: $status) {
    leaveApprovalHR {
      id
      requestedOn
      leaveType{
        leaveType
      }
      leaveFrom
      leaveTill
      totalDays
      halfDay
      reason
      status
      teamleaderId
      teamApproval
      hrApproval
    }
  }
}
      `;
      }

   
    } else {
      query = `
          mutation leaveManagerApproval($id: String!, $status: String!) {
            leaveapprovalmanager(id: $id, status: $status) {
              leaveApprovalManager {
                id
                requestedOn
                leaveType {
                  leaveType
                }
                leaveFrom
                leaveTill
                totalDays
                halfDay
                reason
                status
                hrApproval
                teamleaderId
                teamApproval
              }
            }
          }
        `;
    }

    //       if (HRRoleLeave) {
    //         console.log('HRRRRR');

    //         query = `
    //             mutation regularizationHRApprove($id: String, $status: String!) {
    //               regularizationApproval(id: $id, status: $status) {
    //                 regularizationApprovalHR {
    //                   checkIn
    //                   checkOut
    //                   reason
    //                   teamleaderId
    //                   status
    //                   user {
    //                     id
    //                   }
    //                 }
    //               }
    //             }
    //           `;
    //       } else if (ManagerLeave) {
    //         console.log('Manager');
    //         query = `
    //             mutation leaveManagerApproval($id:String! $status:String!){
    //   leaveapprovalmanager(id:$id status:$status){
    //     leaveApprovalManager{
    //       id
    //       requestedOn
    //       leaveType{
    //         leaveType
    //       }
    //       leaveFrom
    //       leaveTill
    //       totalDays
    //       halfDay
    //       reason
    //       status
    //       hrApproval
    //       teamleaderId
    //       teamApproval
    //     }
    //   }
    // }
    // }

    //           `;
    //       } else {
    //         console.error("Neither HRregularization nor managerState is true.");
    //         return; // Exit if no condition is met
    //       }

    const variables = {
      id: ID,
      status: statusdata,
    };

    console.log('variables:',variables);
    

    try {
      const response = await axios.post(
        BASEURL, // Replace with your actual GraphQL endpoint
        {
          query: query,
          variables: variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("responseHR:", response.data);

      // console.log(
      //   "Response:",
      //   response.data.data.regularizationApproval.regularizationApprovalHR
      // );

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      if (response.data.data?.leaveapprovalhr?.leaveApprovalHR) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `${statusdata.charAt(0).toUpperCase() + statusdata.slice(1)} successfully!`
,
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/leave-management");
      } else if (
        response.data.data?.leaveapprovalmanager?.leaveApprovalManager
      ) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `${statusdata.charAt(0).toUpperCase() + statusdata.slice(1)} successfully!`
,
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/leave-management");
      }
      // Handle success (e.g., show a success message or navigate)
    } catch (error) {
      console.error("Error in ApproveSubmit:", error);
      // Handle error (e.g., show a user-friendly error message)
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // This will return 'dd/mm/yyyy' format
  }

  const handleclose = () => {
    navigate("/leave-management");
  };

  return (
    <DashboardLayout>
        {confirmationDialog.open && (
              <ConfirmationDialog
                open={confirmationDialog.open}
                title={confirmationDialog.title}
                message={confirmationDialog.message}
                showCancel={confirmationDialog.showCancel}
                showConfirm={confirmationDialog.showConfirm}
                customSection={confirmationDialog.customSection}
                onConfirm={confirmationDialog.onConfirm}
                onCancel={confirmationDialog.onCancel}
              />
            )}
  <Card sx={{ padding: 2, boxShadow: 3 }}>
    <CardHeader
      title={
        <Stack direction="column" spacing={0}>
          <Typography variant="h5" fontWeight="bold" textAlign="center">
            Leave Details
          </Typography>
        </Stack>
      }
    />
    <CardContent>
      <Grid container spacing={1} marginLeft={"4%"}>
        {/* Left Column */}
        <Grid item xs={12} sm={6}>
          <Stack spacing={2}>
            <Typography variant="h6">
              <strong>User Name:</strong>{" "}
              <span style={{ color: "#67748E" }}>
                {employeeData.user?.firstName?.toUpperCase()}
              </span>
            </Typography>
            <Typography variant="h6">
              <strong>Leave Type:</strong>{" "}
              <span style={{ color: "#67748E" }}>
                {employeeData.leaveType?.leaveType=="earned_leave"?"Earned Leave":"sick_leave"?"Sick Leave":employeeData.leaveType?.leaveType}
              </span>
            </Typography>
            <Typography variant="h6">
              <strong>Leave From:</strong>{" "}
              <span style={{ color: "#67748E" }}>{employeeData.leaveFrom}</span>
            </Typography>
            <Typography variant="h6">
              <strong>Leave Till:</strong>{" "}
              <span style={{ color: "#67748E" }}>{employeeData.leaveTill}</span>
            </Typography>
            <Typography variant="h6">
              <strong>Total Days:</strong>{" "}
              <span style={{ color: "#67748E" }}>{employeeData.totalDays}</span>
            </Typography>
          </Stack>
        </Grid>

        {/* Right Column */}
        <Grid item xs={12} sm={6}>
          <Stack spacing={2}>
            <Typography variant="h6">
              <strong>Reason:</strong>{" "}
              <span style={{ color: "#67748E" }}>{employeeData.reason}</span>
            </Typography>
            <Typography variant="h6">
              <strong>Manager Approval:</strong>{" "}
              <span style={{ color: "#67748E" }}>
              {employeeData?.teamApproval == 'approved' ? "Approved": employeeData?.teamApproval == 'rejected'? "Rejected" : employeeData?.teamApproval }
              </span>
            </Typography>
            <Typography variant="h6">
              <strong>HR Approval:</strong>{" "}
              <span style={{ color: "#67748E" }}>
              {employeeData?.hrApproval == 'approved' ? "Approved": employeeData?.hrApproval == 'rejected'? "Rejected" : employeeData?.hrApproval}
              </span>
            </Typography>
            <Typography variant="h6">
              <strong>Status:</strong>{" "}
              <span style={{ color: "#67748E" }}>
              {employeeData?.status == 'approved' ? "Approved": employeeData?.status == 'rejected'? "Rejected" : employeeData?.status}

                </span>
            </Typography>
          </Stack>
        </Grid>
      </Grid>

      {/* Close and Action Buttons */}
      <Grid container spacing={2} justifyContent="center" marginTop={4}>
        {display && (
          <>
            <Grid item>
              <MaterialButton
                variant="contained"
                color="primary"
                onClick={() => handleAddLeave("approved")}
              >
                Approve
              </MaterialButton>
            </Grid>
            <Grid item>
              <MaterialButton
                variant="contained"
                color="secondary"
                onClick={() => handleAddLeave("rejected")}
              >
                Reject
              </MaterialButton>
            </Grid>
          
          </>
        )}
         <Grid item>
              <MaterialButton
                variant="contained"
                color="dark"
                onClick={() => handleclose()}
              >
                Close
              </MaterialButton>
            </Grid>
      </Grid>
      
    </CardContent>
  </Card>
</DashboardLayout>

  );
}

export default LeaveApproval;
